

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// UPDATEBLOGSECTIONFORREAPPROVAL
// UPDATEBLOGSECTIONFORREAPPROVAL


const UPDATEBLOGSECTIONFORREAPPROVAL= createAsyncThunk(
  "updateBlogSectionForReApproval/updateBlogSectionForReApproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateBlogSectionForReApprovalSlice = createSlice({
  name: "updateBlogSectionForReApprovalSlice",
  initialState: {
    updateBlogSectionForReApproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateBlogSectionForReApproval: (state) => {
        state.updateBlogSectionForReApproval.loading = false
        state.updateBlogSectionForReApproval.error = false
        state.updateBlogSectionForReApproval.data = []
        state.updateBlogSectionForReApproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEBLOGSECTIONFORREAPPROVAL.fulfilled, (state, action) => {
      state.updateBlogSectionForReApproval = {
        ...state.updateBlogSectionForReApproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEBLOGSECTIONFORREAPPROVAL.pending, (state, action) => {
      state.updateBlogSectionForReApproval = {
        ...state.updateBlogSectionForReApproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEBLOGSECTIONFORREAPPROVAL.rejected, (state, action) => {
      state.updateBlogSectionForReApproval = {
        ...state.updateBlogSectionForReApproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateBlogSectionForReApprovalAction = {
    UPDATEBLOGSECTIONFORREAPPROVAL,
};

export { updateBlogSectionForReApprovalAction };
export default updateBlogSectionForReApprovalSlice.reducer;
export const {setInitialStateOfupdateBlogSectionForReApproval} = updateBlogSectionForReApprovalSlice.actions
